if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.quantityInput = this.querySelector(".quantity__input");        

        if (document.querySelector("cart-drawer")) this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
        if (this.quantityInput != null) {
          this.quantityInput.addEventListener("change", () => {
            this.addVariantId();
            this.changeVariantId();
            this.resetInputChecked();
          });
        }

        if (document.querySelectorAll(".certificate__item input").length > 0) {
          this.addVariantId();
          this.changeVariantId();
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();
        this.handleCustomBranding();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);

        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        if (document.querySelector(".booking__form")) {
          config.body = this.createNewFormData(formData);
          config.headers["Content-Type"] = "application/json";
        } else {
          config.body = formData;
        }

        this.resetInputChecked();

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, { source: "product-form", productVariantId: formData.get("id"), cartData: response });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty")) this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add("hidden");
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message");

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      handleCustomBranding() {
        const input = document.querySelector(".custom-branding__checkbox input");
        if (input) {
          input.checked = false;
        }
      }

      changeVariantId() {
        const inputs = document.querySelectorAll(".certificate__item input");
        let variantIdNoneCertificate = document.querySelector(".booking__form .js-digital-certificate[data-variant-id]").getAttribute("data-variant-id");
        let variantId = document.querySelector(".booking__form .js-hard-certificate[data-variant-id]").getAttribute("data-variant-id");  

        inputs.forEach((input) => {
          input.addEventListener("change", () => {
            if (input.checked) {
              input.setAttribute("data-variant-id", variantId);
            } else {
              input.setAttribute("data-variant-id", variantIdNoneCertificate);
            }
          });
        });
      }

      addVariantId() {
        const inputs = document.querySelectorAll(".certificate__item input");

        let variantIdNoneCertificate = document.querySelector(".booking__form .js-digital-certificate[data-variant-id]").getAttribute("data-variant-id");
        inputs.forEach((input) => {
          input.setAttribute("data-variant-id", variantIdNoneCertificate);
        });
      }

      resetInputChecked() {
        if (document.querySelectorAll(".certificate__item input").length > 0) {
          const inputs = document.querySelectorAll(".certificate__item input");
          let variantIdNoneCertificate = document.querySelector(".booking__form .js-digital-certificate[data-variant-id]").getAttribute("data-variant-id");

          if (inputs.length > 0) {
            inputs.forEach(input => {
              if (input.checked) {
                input.setAttribute("data-variant-id", variantIdNoneCertificate);
                input.checked = false;
              }
            });          
          }
        }
      }

      createNewFormData(formData) {
        function checkString(myString) {
          var hasAsterisk = /\*/.test(myString);
          var hasNoNumber = !/\d/.test(myString);
          return hasAsterisk && hasNoNumber;
        }

        function getNumberAfterAsterisk(myString) {
          var match = myString.match(/\*\s*(\d+)/);
          return match ? match[1] : null;
        }

        // Find keys without numbers to number them
        Array.from(formData.keys())
          .filter((key) => key.includes("properties") && checkString(key))
          .forEach((key) => {
            let value = formData.get(key);
            formData.set(key.replace("*", "*1"), value);
            formData.delete(key);
          });

        // Get the serial number of the student purchasing the certificate
        let numbers = Array.from(formData.keys())
          .filter((key) => key.includes("Hard copy certificate"))
          .map((a) => Number(formData.get(a)));

        // Get properties as Date and divide the array
        let date;
        let hasCerificate = [];
        let noneCertificate = [];

        for (const pair of formData.entries()) {
          if (pair[0].includes("Date")) date = pair[1];

          if (pair[0].includes("properties") && !pair[0].includes("Hard copy certificate") && !pair[0].includes("Date")) {
            if (numbers.find((number) => number == getNumberAfterAsterisk(pair[0]))) hasCerificate.push(pair);
            else noneCertificate.push(pair);
          }
        }

        let objectsCertificate = [];
        let objectsNoneCertificate = [];
        
        hasCerificate.map(([key, value]) => {
          // Process the key if necessary, for example, take the key in []
          const match = key.match(/\[([^\]]+)\]/);
          const processedKey = match ? match[1] : key;
        
          // Store the key-value pair into a resultObject object
          objectsCertificate[processedKey] = value;
        });

        noneCertificate.map(([key, value]) => {
          // Process the key if necessary, for example, take the key in []
          const match = key.match(/\[([^\]]+)\]/);
          const processedKey = match ? match[1] : key;
        
          // Store the key-value pair into a resultObject object
          objectsNoneCertificate[processedKey] = value;
        });

        let products = [];
        let inputsChecked = document.querySelectorAll(".certificate__item input:checked");
        let inputsUnChecked = document.querySelectorAll(".certificate__item input:not(:checked)");

        
        if (inputsChecked.length > 0) {
          console.log(inputsChecked[0].getAttribute("data-variant-id"));
          let productHasCertificate = {
            quantity: inputsChecked.length,
            id: Number(inputsChecked[0].getAttribute("data-variant-id")),
            properties: {
              Date: date,
              ...objectsCertificate
            },
          };
          products.push(productHasCertificate);
        }

        if (inputsUnChecked.length > 0) {
          let productNoneCertificate = {
            quantity: inputsUnChecked.length,
            id: Number(inputsUnChecked[0].getAttribute("data-variant-id")),
            properties: {
              Date: date,
              ...objectsNoneCertificate
            },
          };
          products.push(productNoneCertificate);
        }

        let arrProduct = {
          items: products,
          sections: formData.get("sections"),
          sections_url: formData.get("sections_url"),
        };

        return JSON.stringify(arrProduct);
      }
    }
  );
}
